import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuthContext } from 'src/auth/hooks';

const LineLoginCallback = () => {
  const { handleLineLogin } = useAuthContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      handleLineLogin(token);
      navigate('/dashboard/user/cardbusiness');
    } else {
      console.error('Token not found in URL');
    }
  }, [searchParams, navigate, handleLineLogin]);

  return (
    <div>
      <p>Loading...</p>
    </div>
  );
};

export default LineLoginCallback;
